<template>
  <div :class="isMobile ? 'application-section card-payment' : ''">
    <section id="card-payment">
      <p class="disclaimer-poppin">
        Please make sure you have read our
        <a href="https://www.rcpharm.org/membership-terms-and-conditions" target="_blank">
          Membership Terms and Conditions.
        </a>
      </p>
      <VueRpsBraintree :authUrl="braintreeOptions.tokenApi"
                       :amountIn="amount"
                       :paymentUrl="braintreeOptions.paymentApi"
                       :logUrl="braintreeOptions.logApi"
                       :lineItemType="lineItemType"
                       :dnnModuleOptions='dnnModuleOptions'
                       @PaymentComplete='confirm'
                       :userInformation='userInformation'
                       :googleEnvironment='googleEnvironment'
                       @Cancel='$emit("returnToOption")'
                       @paymentMethodChosen='paymentMethodSelected' />
    </section>
  </div>
</template>
<script>
import apiOptions from '@/api/options';
import accounting from 'accounting-js';
import {
  mapGetters, mapState, mapMutations,
} from 'vuex';
import Manager from '../applicationManager';
import Ga from '../ga';

export default {
  name: 'CardPayment',
  data() {
    return {
      lineItemType: 'MemberApplication',
      dnnModuleOptions: {
        header: apiOptions().headers,
      },
    };
  },
  methods: {
    ...mapMutations(['setCardPaymentResult']),
    async confirm(result) {
      if (result.IsSuccess) {
        const paymentResult = await Manager.postCardCompleteBraintree({
          amount: accounting.unformat(this.paymentOption.TotalAmountDue),
          transactionStatus: 'Y',
          transactionId: result.TransactionId,
          opportunityId: this.application.OpportunityId,
        });
        this.setCardPaymentResult(paymentResult);
        this.$emit('completed');
      } else {
        console.log('There has been an error with braintree payment.');
      }
    },
    paymentMethodSelected(paymentMethod) {
      Ga.sendCardPaymentType(this.$store.state.application.Type, paymentMethod);
    },
  },
  computed: {
    ...mapGetters(['getCorrespondence', 'personalDetailWithUserId']),
    ...mapState(['isMobile', 'application', 'paymentOption', 'braintreeOptions']),
    googleEnvironment() {
      return {
        env: process.env.VUE_APP_GOOGLE_ENV,
        merchant: process.env.VUE_APP_GOOGLE_MERCHANT,
      };
    },
    userInformation() {
      const correspondence = this.getCorrespondence;
      const personDetail = this.personalDetailWithUserId;
      return {
        firstName: personDetail.firstname,
        lastName: personDetail.lastname,
        email: personDetail.email,
        phoneNumber: correspondence.phoneNumber,
        userId: personDetail.userId,
        address: {
          addressLine1: correspondence.addressLine1,
          addressLine2: correspondence.addressLine2,
          addressLine3: correspondence.addressLine3,
          town: correspondence.town,
          country: correspondence.country,
          postcode: correspondence.postcode,
        },
      };
    },
    amount() {
      return accounting.unformat(this.paymentOption.TotalAmountDue);
    },
  },
};
</script>
<style lang="scss">
  @import '../styles/_mixins.scss';
  .mobile-view div.card-payment section input {
    max-width: unset;
  }
  #card-payment p.disclaimer-poppin {
    @include DefaultPoppinFont();
    margin: 15px;
  }

</style>
